export const priceCheck = (price: number) => (price < 0 ? 0 : price);

/** Round to cents and format for display (avoids float artifacts like 33.599999999999994). */
export function formatPriceForDisplay(amount: number): string {
  const n = priceCheck(amount);
  const rounded = Math.round(n * 100) / 100;
  return rounded.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
